(function () {
  if (window.__rapiReorderLoaded) return;
  window.__rapiReorderLoaded = true;

  // Start cloaking immediately to prevent initial original layout flash
  try { document.documentElement.classList.add('rapi-cloak'); } catch (e) {}

  const SELECTOR_PACKS = '.rapi-bundles__bars, .rapi-bundles, .rapi-bundles_bar_wrapper, .rapi-bundles_bar';

  function waitFor(selector, timeout = 10000) {
    return new Promise((resolve, reject) => {
      const found = document.querySelector(selector);
      if (found) return resolve(found);
      const mo = new MutationObserver((mutations, obs) => {
        const el = document.querySelector(selector);
        if (el) {
          obs.disconnect();
          resolve(el);
        }
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(() => {
        mo.disconnect();
        reject(new Error('timeout waiting for ' + selector));
      }, timeout);
    });
  }

  function safeText(el) {
    return el ? (el.textContent || '').trim() : '';
  }

  function debounce(fn, wait) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  // The original init function you provided, kept intact except now it is callable by root
  function initRapiReorder(rapiRoot) {
    try {
      if (!rapiRoot || rapiRoot.dataset.rapiReordered === '1') return;
      rapiRoot.dataset.rapiReordered = '1';

      const packsRow = rapiRoot.querySelector('.rapi-bundles__bars, .rapi-bundles, .rapi-bundles_bar_wrapper, .rapi-bundles_bar');
      const subToggle = rapiRoot.querySelector('.rapi-subscription-simpleButton, .rapi-subscription');
      const frequencySelect = rapiRoot.querySelector('.rapi-bundles__bar-variant-selects, .rapi-bundles__bar-variant-select, select');
      const submitRow = rapiRoot.querySelector('.quantity-submit-row__submit, .rapi-add-to-cart') || document.querySelector('.quantity-submit-row__submit, .rapi-add-to-cart');

      if (!packsRow || !subToggle) 
        document.documentElement.classList.remove("rapi-cloak");
        return;

      const wrapper = document.createElement('div');
      wrapper.className = 'rapi-steps-wrapper';

      const step1Title = document.createElement('div');
      step1Title.className = 'rapi-step-title';
      step1Title.textContent = 'STEP 1 - HOW MANY PACKS?';

      const step1Container = document.createElement('div');
      step1Container.className = 'rapi-packs-row';

      const frag = document.createDocumentFragment();
      while (packsRow.firstChild) {
        frag.appendChild(packsRow.firstChild);
      }
      step1Container.appendChild(frag);

      const step2Title = document.createElement('div');
      step2Title.className = 'rapi-step-title';
      step2Title.textContent = 'STEP 2 - ONE-TIME OR SUBSCRIBE?';

      const step2Container = document.createElement('div');
      step2Container.className = 'rapi-sub-step';
      step2Container.appendChild(subToggle);

      const freqRow = document.createElement('div');
      freqRow.className = 'rapi-frequency-row';
      const freqLabel = document.createElement('div');
      freqLabel.textContent = 'Deliver every';
      freqLabel.style.fontWeight = '600';
      freqLabel.style.minWidth = '110px';
      freqRow.appendChild(freqLabel);
      if (frequencySelect) freqRow.appendChild(frequencySelect);

      wrapper.appendChild(step1Title);
      wrapper.appendChild(step1Container);
      wrapper.appendChild(step2Title);
      wrapper.appendChild(step2Container);
      wrapper.appendChild(freqRow);

      const parent = packsRow.parentElement || rapiRoot;
      try {
        parent.replaceChild(wrapper, packsRow);
      } catch (err) {
        parent.insertBefore(wrapper, packsRow);
        packsRow.remove();
      }

      try {
        packsRow.style.display = 'none';
        packsRow.setAttribute('aria-hidden', 'true');
      } catch (e) { /* ignore */ }

      let originalBtn = null;
      if (submitRow) originalBtn = submitRow.querySelector('button') || submitRow;
      if (originalBtn) {
        originalBtn.style.opacity = '0';
        originalBtn.style.pointerEvents = 'none';
        originalBtn.style.position = 'relative';
        originalBtn.setAttribute('aria-hidden', 'true');
      }

      if (!document.querySelector('.rapi-buy-cta')) {
        const ctaWrap = document.createElement('div');
        ctaWrap.className = 'rapi-buy-cta';
        const bigBtn = document.createElement('button');
        bigBtn.type = 'button';
        bigBtn.className = 'rapi-primary-cta';
        bigBtn.innerHTML = '<span class="rapi-cta-label">Add to cart</span><span class="rapi-cta-price"></span>';
        ctaWrap.appendChild(bigBtn);

        if (wrapper && wrapper.parentNode) wrapper.parentNode.insertBefore(ctaWrap, wrapper.nextSibling);
        else rapiRoot.appendChild(ctaWrap);

        bigBtn.addEventListener('click', function () {
          try {
            if (originalBtn) originalBtn.click();
          } catch (e) {
            console.warn('rapi: click proxy failed', e);
          }
        });
      }

      function readSelection() {
        const info = { priceText: '', subType: '', freqText: '' };

        const selectedInput = rapiRoot.querySelector('.rapi-bundles__bar input[type="radio"]:checked');
        let selectedBar = selectedInput ? selectedInput.closest('.rapi-bundles__bar') : rapiRoot.querySelector('.rapi-bundles__bar.rapi-bundles__bar--selected, .rapi-bundles__bar[aria-pressed="true"]');
        if (!selectedBar) selectedBar = rapiRoot.querySelector('.rapi-bundles__bar, .rapi-bundles_bar');

        if (selectedBar) {
          const priceEl = selectedBar.querySelector('.rapi-bundles__bar-price, .price, .rapi-price');
          info.priceText = safeText(priceEl);
        }

        const subInput = rapiRoot.querySelector('.rapi-subscription-simpleButton input[type="radio"]:checked');
        if (subInput) {
          const parent = subInput.closest('label, div') || subInput.parentElement;
          info.subType = safeText(parent);
        } else {
          const subSel = rapiRoot.querySelector('.rapi-subscription-simpleButton > div[aria-pressed="true"], .rapi-subscription-simpleButton > div.rapi-selected');
          info.subType = safeText(subSel);
        }

        if (frequencySelect) {
          if (frequencySelect.tagName === 'SELECT') info.freqText = safeText(frequencySelect.options[frequencySelect.selectedIndex]);
          else info.freqText = safeText(frequencySelect);
        }

        return info;
      }

      const updateCTA = debounce(function () {
        try {
          const info = readSelection();
          const labelEl = document.querySelector('.rapi-buy-cta .rapi-cta-label');
          const priceEl = document.querySelector('.rapi-buy-cta .rapi-cta-price');
          if (!labelEl || !priceEl) return;

          const lc = (info.subType || '').toLowerCase();
          const isSubscribe = lc.indexOf('subscribe') !== -1 || lc.indexOf('save') !== -1;

          labelEl.textContent = isSubscribe ? 'Subscribe & Save' : 'Add to cart';
          priceEl.textContent = info.priceText ? ' - ' + info.priceText : '';
        } catch (e) { /* ignore */ }
      }, 120);

      rapiRoot.addEventListener('change', updateCTA, true);
      rapiRoot.addEventListener('click', updateCTA, true);

      const smallMo = new MutationObserver(debounce(updateCTA, 200));
      smallMo.observe(wrapper, { childList: true, subtree: true });

      setTimeout(updateCTA, 160);
      setTimeout(() => { try { smallMo.disconnect(); } catch (e) { } }, 30000);

      // success: reveal page now that reorder is in place
      try { document.documentElement.classList.remove('rapi-cloak'); } catch (e) {}

    } catch (err) {
      console.error('rapi-reorder init error', err);
    }
  }

  // Helper: find best root for a node
  function findRoot(node) {
    if (!node) return document;
    return node.closest('[class*="rapi"]') || node.closest('.main-product') || node.closest('form') || node;
  }

  // Check if wrapper is present in a root
  function wrapperPresent(root) {
    try {
      return !!root.querySelector('.rapi-steps-wrapper');
    } catch (e) {
      return false;
    }
  }

  // Try init function - idempotent, will re-init roots where wrapper disappeared
  function tryInitAll() {
    const nodes = Array.from(document.querySelectorAll(SELECTOR_PACKS));
    if (!nodes.length) return;

    nodes.forEach(node => {
      const root = findRoot(node);
      if (!root) return;

      // If flagged as initialized but our wrapper was removed by RAPI re-render, clear flag so we can re-init
      if (root.dataset.rapiReordered === '1' && !wrapperPresent(root)) {
        try { delete root.dataset.rapiReordered; } catch (e) { try { root.removeAttribute('data-rapi-reordered'); } catch (e2) {} }
      }

      // Only init when not already flagged
      if (root.dataset.rapiReordered !== '1') {
        initRapiReorder(root);
      }
    });
  }

  // Initial fast attempt using waitFor
  waitFor(SELECTOR_PACKS, 10000).then(() => {
    tryInitAll();
  }).catch(() => {
    // still attempt general init pass even if waitFor timed out
    tryInitAll();
  });

  // Observe document for new RAPI insertions and retry debounced
  const pageObserver = new MutationObserver(debounce(function () {
    tryInitAll();
  }, 220));
  pageObserver.observe(document.documentElement || document, { childList: true, subtree: true });

  // Extra timed retries for slow renders
  setTimeout(tryInitAll, 700);
  setTimeout(tryInitAll, 2000);
  setTimeout(tryInitAll, 5000);

  // safety: if nothing removed the cloak after 3500ms, reveal so page is not permanently hidden
  setTimeout(() => { try { document.documentElement.classList.remove('rapi-cloak'); } catch (e) {} }, 3500);

})();